import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SwitchComponent } from '../../../../../Components';
import { isEmpty } from 'lodash';

const PropertyDescriptionForm = ({
  localFormChangeHandler,
  localFormSelection,
  setDisabledPageToggle,
}) => {
  const parentTranslationPath = 'SmartProposal';
  const translationPath = 'PropertyDescriptionForm.';
  const { t } = useTranslation(parentTranslationPath);
  const [disabled, setDisabled] = React.useState({
    showPage: false,
    showGeneralFacts: false,
    showProjectFacts: false,
  });
  useEffect(() => {
    if (localFormSelection.data?.projectDescriptionData) {
      const { projectFacts, projectDetails } =
        localFormSelection.data.projectDescriptionData;
      const emptyProjectFacts =
        !projectFacts || Object.values(projectFacts).every((item) => !item);
      if (isEmpty(projectDetails.propertyOverView) && emptyProjectFacts) {
        localFormChangeHandler('edit', {
          ...localFormSelection,
          showGeneralFacts: false,
          showProjectFacts: false,
          showPage: false,
        });
        setDisabled({
          showPage: true,
          showGeneralFacts: true,
          showProjectFacts: true,
        });
        setDisabledPageToggle(true);
      } else if (isEmpty(projectDetails)) {
        localFormChangeHandler('showGeneralFacts', false);
        setDisabled((prev) => ({
          ...prev,
          showGeneralFacts: true,
        }));
      } else if (emptyProjectFacts) {
        localFormChangeHandler('showProjectFacts', false);
        setDisabled((prev) => ({
          ...prev,
          showProjectFacts: true,
        }));
      }
    }
  }, [localFormSelection.data?.projectDescriptionData]);

  return (
    <>
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>Property description section</p>
        </div>
        <div>
          <SwitchComponent
            idRef='descriptionSectionRef'
            themeClass='thick-theme'
            isChecked={localFormSelection?.showGeneralFacts || false}
            labelValue={`${
              localFormSelection?.showGeneralFacts ? 'show' : 'hide'
            }`}
            parentTranslationPath={parentTranslationPath}
            translationPath={''}
            onChangeHandler={(_, isChecked) =>
              localFormChangeHandler('edit', {
                ...(localFormSelection || {}),
                showGeneralFacts: isChecked,
                showPage: isChecked || localFormSelection.showProjectFacts,
              })
            }
            isDisabled={disabled.showGeneralFacts}
          />
        </div>
      </div>
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>Project facts section</p>
        </div>
        <div>
          <SwitchComponent
            idRef='ProjectFactsRef'
            themeClass='thick-theme'
            isChecked={localFormSelection?.showProjectFacts || false}
            labelValue={`${
              localFormSelection?.showProjectFacts ? 'show' : 'hide'
            }`}
            parentTranslationPath={parentTranslationPath}
            translationPath={''}
            onChangeHandler={(_, isChecked) =>
              localFormChangeHandler('edit', {
                ...(localFormSelection || {}),
                showProjectFacts: isChecked,
                showPage: localFormSelection.showGeneralFacts || isChecked,
              })
            }
            isDisabled={disabled.showProjectFacts}
          />
        </div>
      </div>
    </>
  );
};

export default PropertyDescriptionForm;
